// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__YUV4Z","title":"styles_title__1eoFi","description":"styles_description__GIPov","buttonContainer":"styles_buttonContainer__lu7De"};